<template lang="pug">
.page-header
    IQToolMiddlePaneHeader.header(:header="$t('settings_tab.campaign_tab.manage.title')"
                         :title="pageTitle"
                         @goToListPage="back"
                         )

EditArea
  template(#content)
    .field-container.full-width.is-required
      label {{  $t(`${basePath}.name`) }}
      aiq-input(v-model="campaign.name"
                :disabled="viewMode"
                :min-length="250")
    .field-container.full-width
      label {{ $t(`${basePath}.description`) }}
      aiq-input(v-model="campaign.description"
                :disabled="viewMode"
                type="textarea"
                :min-length="250")
    .field-container.full-width.is-required
      label {{ $t(`${basePath}.channel`) }}
      aiq-select(v-model="campaign.channel"
        :disabled="viewMode || disableChannelSelect"
        :suffix-icon="Icon.CaretBottom"
        )
        aiq-option(v-for="channel in channelList" :key="channel.value" :label="channel.label" :value="channel.value")
    .field-group
      .group-item(v-for="(item, index) in campaign.intervals.items" :key="item.id")
        .group-header
          .group-name {{ $t(`${basePath}.group`) }} {{ index + 1 }}
          .position-action
            aiq-button(class="group-btn" :disabled="viewMode || index === 0" @click="moveAction(index, 'up')") {{ $t(`${basePath}.previous`) }}
            aiq-button(class="group-btn" :disabled="viewMode || index === campaign.intervals.items.length - 1" @click="moveAction(index, 'down')") {{ $t(`${basePath}.next`) }}
        .field-container.is-required(v-if="featureFlags.ENABLE_AGENT_CAMPAIGN_NOTIFICATION")
          label {{ $t(`${basePath}.operation`) }}
            aiq-tooltip(effect="dark"
              :show-after="1000"
              :content="$t(`${basePath}.action_tooltip`)")
              fa-icon.question-mark(:icon="['fas', 'circle-question']")
          aiq-select(v-model="item.action"
            :disabled="viewMode"
            :suffix-icon="Icon.CaretBottom")
            aiq-option(v-for="action in actionsList" :key="action.value" :label="action.label" :value="action.value")
        .field-container.is-required(v-if="item.action !== 'command'")
          label {{ $t(`${basePath}.template`) }}
            aiq-tooltip(effect="dark"
              :show-after="1000"
              :content="$t(`${basePath}.template_tooltip`)")
              fa-icon.question-mark(:icon="['fas', 'circle-question']")
          CustomDropdown(:htmlList="getTemplatePerInterval(item.action, campaign.channel)",
                        :itemValue="item.template",
                        :itemIndex="index",
                        @change="handleTemplateChange",
                        @open="handleOpen",
                        :viewMode="viewMode")
        .field-container(v-if="item.action === 'command' && featureFlags.ENABLE_COMMAND_CAMPAIGN")
          label {{ $t(`${basePath}.command`) }}
            aiq-tooltip(effect="dark"
              :show-after="1000"
              :content="$t(`${basePath}.command_tooltip`)")
              fa-icon.question-mark(:icon="['fas', 'circle-question']")
          aiq-select(v-model="item.command_type"
            :disabled="viewMode"
            :suffix-icon="Icon.CaretBottom")
            aiq-option(v-for="command in commandList" :key="command.name" :label="command.name + ' - ' + command.description" :value="command.name")
        .field-container(v-if="item.action === 'command' && !addNote(index) && canShowCommandParameters(index) && featureFlags.ENABLE_COMMAND_CAMPAIGN")
          label {{ $t(`${basePath}.command_values`) }}
            aiq-tooltip(effect="dark"
              :show-after="1000"
              :content="$t(`${basePath}.command_values_tooltip`)")
              fa-icon.question-mark(:icon="['fas', 'circle-question']")
          aiq-select(v-model="item.command_values"
            :disabled="viewMode"
            v-if="item.command_type !== '/bot'"
            :suffix-icon="Icon.CaretBottom"
            value-key="id"
            multiple)
            aiq-option(v-for="value in commandParameters[index]" :key="value.id" :label="value.name" :value="value")
          aiq-select(v-model="item.enabled_bot"
            :disabled="viewMode"
            v-else
            :suffix-icon="Icon.CaretBottom"
            value-key="id")
            aiq-option(v-for="value in commandParameters[index]" :key="value.id" :label="value.name" :value="value")
        .field-container(v-if="item.action === 'command' && addNote(index) && featureFlags.ENABLE_COMMAND_CAMPAIGN")
          label {{ $t(`${basePath}.add_note`) }}
            aiq-tooltip(effect="dark"
              :show-after="1000"
              :content="$t(`${basePath}.add_note_tooltip`)")
              fa-icon.question-mark(:icon="['fas', 'circle-question']")
          .custom-rich-text-container
              rich-text(@update="(payload) => { onUpdateRichTextEditor(index, payload) }"
                  :msg="item.command_values_note"
                  :inChat="false"
                  :readOnlyMode="viewMode"
                  :place-holder="$t(`${basePath}.add_note_tooltip`)")
        .field-container
          h6 {{ $t(`${basePath}.interval`) }}
            aiq-tooltip(effect="dark"
              :show-after="1000"
              :content="$t(`${basePath}.interval_tooltip`)")
              fa-icon.question-mark(:icon="['fas', 'circle-question']")
        .field-container.is-required
          label {{ $t(`${basePath}.start_date_info`) }}
            aiq-input(v-model="item.duration" type="number" min="1" :disabled="viewMode")
        .field-container.is-required
          label {{ $t(`${basePath}.send_time`) }}
            aiq-tooltip(effect="dark"
              :show-after="1000"
              :content="$t(`${basePath}.send_time_tooltip`)")
              fa-icon.question-mark(:icon="['fas', 'circle-question']")
            aiq-time-picker(v-model="item.send_at"
              :disabled="viewMode"
              :clearable="false"
              format="hh:mm a"
              :max-length="50"
              placeholder="HH:MM")
        .field-container
          .btn-group
            .last-grp-btn(v-if="!viewMode && index === campaign.intervals.items.length - 1")
              aiq-button(type="primary" class="group-btn" @click="addInterval") {{ $t(`${basePath}.add`) }}
              aiq-button(type="danger" v-if="campaign.intervals.items.length > 1" class="group-btn" @click="removeInterval(index)") {{ $t('global.delete') }}
            aiq-button(type="danger" class="group-btn" v-if="!viewMode && index !== campaign.intervals.items.length - 1" @click="removeInterval(index)") {{ $t('global.delete') }}
    .field-container
      label {{ $t(`${basePath}.active`) }}
      aiq-switch.switch(v-model="campaign.is_active" :class="campaign.is_active ? 'active' : 'inactive'" :disabled="viewMode")
    .required-label-wrapper(v-if="!viewMode")
      .required-label
        span *Required
    .footer
      aiq-button(v-if="!viewMode && !isNew" type="danger" :plain="true" @click="deleteCampaign") {{ $t('global.delete') }}
      aiq-button(@click="back(false)") {{ viewMode ? $t('global.close') : $t('global.cancel') }}
      aiq-button(v-if="!viewMode" class="save-btn required" :disabled="!isSubmittable" type="primary" @click="saveCampaign") {{ $t('global.save') }}
aiq-dialog.modal-editor(:title="modalTitle"
            v-model="showModal"
            :show-close="true"
            :close-on-click-modal="true"
            :close-on-press-escape="true"
            :before-close="handleBeforeClose"
             @close="closeModal")
    MessageTempate(v-if="showModal"
                    :selectedTemplateName="selectedTemplateName"
                    :inModal = "true"
                    :channel="addChannel"
                    :messageTemplateMode="messageTemplateMode"
                    :templates="completeTemplates.message_templates || []"
                    @update="updateTemplate"
                    @close="closeModal"
                    @fieldChanged="messageTemplateUpdated = true"
                    )
</template>

<script>
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import dayjs from '@/localPlugins/dayjs';
import { confirmBeforeDialogClose } from '@/libs';
import CustomDropdown from '@/components/CustomDropdown.vue';
import IQToolMiddlePaneHeader from '@/pages/IQTools/Partials/IQToolMiddlePaneHeader/IQToolMiddlePaneHeader.vue';
import MessageTempate from '../Agents/children/MessageTemplate/MessageTempate.vue';
import EditArea from '@/components/EditArea.vue';
import { mapState } from 'vuex';
import { useTimeZone, getTimeZoneAbbr } from '@/libs';
import commands from './commands';
import commandDefinitions from '@/libs/commandDefinitions.js';
import RichText from '@/components/RichText/RichText.vue';
import mitt from 'mitt';
import { AGENT_LIMIT, CATEGORY_LIMIT, TAG_LIMIT, TEAM_LIMIT } from '@/constants/pagination';
const LIMIT = 1000;
export default {
  name: 'CampaignEdit',
  components: {
    IQToolMiddlePaneHeader,
    EditArea, CustomDropdown, MessageTempate, RichText,
  },
  provide() {
    return {
      richTextEventEmitter: this.richTextEventEmitter,
    };
  },
  data() {
    return {
      campaign: {
        name: '',
        description: '',
        channel: 'webchat',
        intervals: {
          items: [{ id: 1, ...{
            action: 'message',
            send_at: null,
            duration: 1,
            template: '',
            command_type: '',
            command_values: [],
            enabled_bot: '',
            command_values_note: '',
          } }],
        },
        is_active: true,
      },
      campaignClone: {},
      isNew: true,
      viewMode: false,
      basePath: 'settings_tab.campaign_tab.edit',
      completeTemplates: {},
      templates: [],
      timezone: '',
      tzAbbr: '',
      richTextEventEmitter: mitt(),
      showModal: false,
      currentIndex: null,
      modalTitle: '',
      selectedTemplateName: null,
      messageTemplateUpdated: false,
      messageTemplateMode: '',
      addChannel: '',
      disableChannelSelect: false,
      actionsList: [],
      commandList: commands,
      commandParameters: {},
      noteMsg: {},
    };
  },
  watch: {
    'campaign.channel': {
      handler(val) {
        const no_channel = val === 'none';
        if (no_channel) {
          this.actionsList = [
            ...(this.featureFlags.ENABLE_AGENT_CAMPAIGN_NOTIFICATION
        && this.canView('/settings/campaigns/notification/new') ? [{
                label: this.$t(`${this.basePath}.notify_an_agent`),
                value: 'notification',
              }] : []),
            ...(this.featureFlags.ENABLE_COMMAND_CAMPAIGN ? [{
              label: this.$t(`${this.basePath}.command`),
              value: 'command',
            }] : []),
          ];
        } else {
          this.actionsList = [
            ...(this.featureFlags.ENABLE_AGENT_CAMPAIGN_NOTIFICATION
        && this.canView('/settings/campaigns/notification/new') ? [{
                label: this.$t(`${this.basePath}.notify_an_agent`),
                value: 'notification',
              }] : []),
            {
              label: this.$t(`${this.basePath}.send_a_message`),
              value: 'message',
            },
            ...(this.featureFlags.ENABLE_COMMAND_CAMPAIGN ? [{
              label: this.$t(`${this.basePath}.command`),
              value: 'command',
            }] : []),
          ];
        }
      },
      immediate: true,
    },
    'campaign.intervals.items.length': {
      handler(intervalLength) {
        this.disableChannelSelect = (intervalLength || 0) > 1;
      },
      immediate: true,
    },
    'commandTypes': {
      handler(newTypes, oldTypes) {
        newTypes.forEach((type, index) => {
          const previousType = oldTypes ? oldTypes[index] : undefined;
          if (type && type !== previousType) {
            if (previousType) {
              this.campaign.intervals.items[index].command_values = [];
              this.campaign.intervals.items[index].command_values_note = '';
            }
            this.parameterValues(index);

          }
        });
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      featureFlags: state => state.featureFlags.FEATURE_FLAGS,
    }),
    commandTypes() {
      return this.campaign.intervals.items.map(item => item.command_type);
    },

    DEFAULT_INTERVAL() {
      const no_channel = this.campaign.channel === 'none';
      return {
        action: no_channel ? 'notification' : 'message',
        send_at: null,
        duration: 1,
        template: '',
        command_type: '',
        command_values: [],
        enabled_bot: '',
        command_values_note: '',
      };
    },
    channelList() {
      return [
        {
          label: 'SMS',
          value: 'sms',
        },
        {
          label: 'Webchat',
          value: 'webchat',
        },
        ...(this.featureFlags.ENABLE_AGENT_CAMPAIGN_NOTIFICATION
        && this.canView('/settings/campaigns/notification/new') ? [{
            label: 'No Channel',
            value: 'none',
          }] : []),
      ];
    },
    pageTitle() {
      if (this.viewMode) {
        return this.$t(`${this.basePath}.view`);
      }
      if (this.isNew) {
        return this.$t(`${this.basePath}.title`);
      }
      return this.$t(`${this.basePath}.edit`);
    },
    isSubmittable() {
      const { name, intervals } = this.campaign;
      if (name.length < 1) {
        return false;
      }

      if (intervals.items.length < 1) {
        return false;
      }
      //check that every none command interval has a template
      const invalidIntervalsTemplate = intervals.items.filter(interval =>
        (!interval.template || interval.template.length < 1)
          && interval.action !== 'command');
      if (invalidIntervalsTemplate.length > 0) {
        return false;
      }

      //check that every interval has an action
      const invalidIntervalsAction = intervals.items.filter(interval => !interval.action || interval.action.length < 1);
      if (invalidIntervalsAction.length > 0) {
        return false;
      }

      //check that every interval has a send time
      const invalidIntervalsSendTime = intervals.items.filter(interval => !interval.send_at);
      if (invalidIntervalsSendTime.length > 0) {
        return false;
      }

      //check that every command interval requiring parameters has values,
      //except /note which needs a note instead of command_values
      const invalidIntervalsCommandValues = intervals.items.filter(interval => {
        if (interval.action !== 'command') {
          return false;
        }
        const commandDef = this.getCommandObject(interval.command_type);
        if (!commandDef || !commandDef.requiredParameters) {
          return false;
        }
        if (commandDef.name === '/note') {
          return !interval.command_values_note || interval.command_values_note.length < 1;
        }
        return !interval.command_values || interval.command_values.length < 1;
      });
      if (invalidIntervalsCommandValues.length > 0) {
        return false;
      }

      if (!this.isNew) {
        if (isEqual(this.campaign, this.campaignClone)) {
          return false;
        }
      }

      return true;
    },
  },
  unmounted() {
    const content = document.querySelector('.content');

    if (content) {
      content.style.display = 'flex';
      content.style.width = '100%';
    }

  },
  async mounted() {
    const content = document.querySelector('.content');
    this.actionsList = [
      {
        label: this.$t(`${this.basePath}.send_a_message`),
        value: 'message',
      },
      ...(this.featureFlags.ENABLE_AGENT_CAMPAIGN_NOTIFICATION
        && this.canView('/settings/campaigns/notification/new') ? [{
          label: this.$t(`${this.basePath}.notify_an_agent`),
          value: 'notification',
        }] : []),
      ...(this.featureFlags.ENABLE_COMMAND_CAMPAIGN ? [{
        label: this.$t(`${this.basePath}.command`),
        value: 'command',
      }] : []),
    ];

    if (content) {
      content.style.display = 'block';
    }
    await this.getTzAbbr();
    await this.init();

    if (!this.isNew) {
      this.campaign.intervals.items = this.campaign.intervals.items.map(interval => {
        return {
          ...interval,
          send_at: dayjs(interval.send_at).tz(this.timezone).format('YYYY-MM-DD HH:mm'),
        };
      });
    }
    this.campaignClone = cloneDeep(this.campaign);

  },
  methods: {
    async init() {
      const params = get(this.$route, 'params.id', '');
      this.viewMode = JSON.parse(get(this.$route, 'query.view', false));
      this.isNew = params === 'new';
      try {
        this.completeTemplates = await this.$store.dispatch('settings/getSetting', {
          name: 'message_template',
        });
        this.templates = get(this.completeTemplates, 'message_templates', []);
        if (!this.isNew) {
          this.campaign = (
            await this.$store.dispatch('campaign/getCampaign', params)
          ).data;
          this.campaign.intervals.items = this.campaign.intervals.items.map(
            (item, index) => {
              return {
                ...item,
                id: index + 1,
              };
            },
          );
        }
      } catch (error) {
        this.$aiq.notify.error('Error fetching campaign');
      }
    },
    onUpdateRichTextEditor(index, payload) {
      this.campaign.intervals.items[index].command_values_note = payload;
    },
    getCommandObject(commandType) {
      return this.commandList.find(c => c.name === commandType);
    },
    canShowCommandParameters(index) {
      const type = this.campaign.intervals.items[index].command_type;
      const hasParameters = this.getCommandObject(type);
      return hasParameters && hasParameters.requiredParameters;
    },
    async getAgentList() {
      // get the list of agents from the command definition stored in cache
      const commandMatched = get(commandDefinitions, 'conversations.agents.attach');
      const list = commandMatched.getParamsList(this.$store).map(p => ({ name: p.name, id: p.id }));
      if (list.length > 0) {
        return list;
      }
      // make a fetch call to get the list of agents if the cache did not return any results
      const agents = await this.$store.dispatch('agents/getAgentsList',
        [{limit: AGENT_LIMIT}, true],
      );
      const agent_data = get(agents, 'data.models', []);
      return agent_data.map(agent => ({ name: agent.fullName, id: agent.id }));
    },
    async getCategoryList() {
      // get the list of categories from the command definition stored in cache
      const commandMatched = get(commandDefinitions, 'conversations.categories.attach');
      const list = commandMatched.getParamsList(this.$store).map(p => ({ name: p.name, id: p.id }));
      if (list.length > 0) {
        return list;
      }
      // make a fetch call to get the list of categories if the cache did not return any results
      const categories = await this.$store.dispatch('categories/getCategoriesList',
        [{limit: CATEGORY_LIMIT}, true],
      );
      const category_data = get(categories, 'data.models', []);
      return category_data.map(category => ({ name: category.name, id: category.id }));
    },
    async getTagList() {
      // get the list of tags from the command definition stored in cache
      const commandMatched = get(commandDefinitions, 'conversations.tags.attach');
      const list = commandMatched.getParamsList(this.$store).map(p => ({ name: p.name, id: p.id }));
      if (list.length > 0) {
        return list;
      }
      // make a fetch call to get the list of tags if the cache did not return any results
      const tags = await this.$store.dispatch('tags/getTagsList',
        [{limit: TAG_LIMIT}, true],
      );
      const tag_data = get(tags, 'data.models', []);
      return tag_data.map(tag => ({ name: tag.name, id: tag.id }));
    },
    async getTeamList() {
      // get the list of teams from the command definition stored in cache
      const commandMatched = get(commandDefinitions, 'conversations.teams.attach');
      const list = commandMatched.getParamsList(this.$store).map(p => ({ name: p.name, id: p.id }));
      if (list.length > 0) {
        return list;
      }
      // make a fetch call to get the list of teams if the cache did not return any results
      const teams = await this.$store.dispatch('teams/getTeamsList',
        [{limit: TEAM_LIMIT}, true],
      );
      const team_data = get(teams, 'data.models', []);
      return team_data.map(team => ({ name: team.name, id: team.id }));
    },
    async getWorkflowList() {
      // get the list of workflows from the command definition stored in cache
      const commandMatched = get(commandDefinitions, 'bot.workflow.init');
      const list = commandMatched.getParamsList(this.$store).map(p => ({ name: p.name, id: p.id }));
      if (list.length > 0) {
        return list;
      }
      // make a fetch call to get the list of workflows if the cache did not return any results
      const workflows = await this.$store.dispatch('workflows/getWorkflowsList',
        [{limit: LIMIT}, true],
      );
      const workflow_data = get(workflows, 'data.data', []);
      return workflow_data.map(workflow => ({ name: workflow.name, id: workflow.id }));
    },

    getBotList() {
      return [{ name: 'enabled', id: '1' }, { name: 'disabled', id: '2' }];
    },
    async parameterValues(index) {
      const command = this.campaign.intervals.items[index].command_type;
      switch (command) {
        case '/assign':
          this.commandParameters[index] = await this.getAgentList();
          break;
        case '/assign_primary_agent':
          this.commandParameters[index] = await this.getAgentList();
          break;
        case '/bot':
          this.commandParameters[index] = this.getBotList();
          break;
        case '/unassign':
          this.commandParameters[index] = await this.getAgentList();
          break;
        case '/unteam':
          this.commandParameters[index] = await this.getTeamList();
          break;
        case '/category':
          this.commandParameters[index] = await this.getCategoryList();
          break;
        case '/lock':
          this.commandParameters[index] = await this.getAgentList();
          break;
        case '/lock_primary_agent':
          this.commandParameters[index] = await this.getAgentList();
          break;
        case '/tag':
          this.commandParameters[index] = await this.getTagList();
          break;
        case '/team':
          this.commandParameters[index] = await this.getTeamList();
          break;
        case '/workflow':
          this.commandParameters[index] = await this.getWorkflowList();
          break;
        default:
          return;
      }
    },
    addNote(index) {
      const action = this.campaign.intervals.items[index].command_type;
      const isNote = this.commandList.find(c => c.name === action);
      return isNote && isNote.name === '/note';
    },
    moveAction(index, direction) {
      const newIndex = direction === 'up' ? index - 1 : index + 1;
      const temp = this.campaign.intervals.items[newIndex];
      this.campaign.intervals.items[newIndex] = this.campaign.intervals.items[index];
      this.campaign.intervals.items[index] = temp;
    },

    handleBeforeClose() {
      if (this.messageTemplateUpdated) {
        confirmBeforeDialogClose(this, this.closeModal);
      } else {
        this.closeModal();
      }
    },
    getTemplatePrefix(template_type) {
      switch (template_type) {
        case 'sms':
          return 'SMS';
        case 'webchat':
          return 'Lynq Up Message';
        case 'notification':
          return 'Notification';
        default:
          return '';
      }
    },
    getTemplatePerInterval(action, channel) {
      const templates = get(this.completeTemplates, 'message_templates', []);
      if (action === 'message') {
        const filteredTemplates = templates.filter(t => {
          return t.template_type === channel;
        });
        return this.computeTemplates(filteredTemplates);
      }
      if (action === 'notification') {
        const filteredTemplates = templates.filter(t => t.template_type === 'notification');
        return this.computeTemplates(filteredTemplates);
      }
      return this.computeTemplates([]);
    },
    computeTemplates(filteredTemplates) {
      let htmlTemplateList = filteredTemplates.map(t => {
        return {
          value: t.title,
          label: `<p>${t.title} (${this.getTemplatePrefix(t.template_type)})</p>`,
        };
      });
      //sort the template by label alphabetically using lodash
      htmlTemplateList = htmlTemplateList.sort((a, b) => a.label.toUpperCase().localeCompare(b.label.toUpperCase()));
      return [
        {
          value: null,
          label: '<p class="add-new"><i class="el-icon-plus"></i> Add New</p>',
        },
        ...htmlTemplateList,
      ];
    },
    async deleteConfirm() {
      try {
        await this.$aiq.confirm(
          this.$t(`${this.basePath}.delete_confirm.title`),
          this.$t(`${this.basePath}.delete_confirm.message`, {
            name: this.campaign.name,
            defaultValue: `Are you sure you want to delete this ${this.campaign.name}?`,
          }),
        );
        return true;
      } catch {
        return false;
      }
    },
    async deleteCampaign() {
      const response = await this.deleteConfirm();
      try {
        if (response) {
          await this.$store.dispatch('campaign/deleteCampaign', this.campaign.id);
          this.$aiq.notify.success('Campaign deleted successfully');
          await this.back(true);
        }
      } catch (_) {
        this.$aiq.notify.error('Error deleting campaign');
      }

    },

    validate() {
      const { name, channel, intervals } = this.campaign;
      if (name.length < 1) {
        this.$aiq.notify.error(this.$t(`${this.basePath}.validation.name_required`));
        return false;
      }

      if (channel.length < 1) {
        this.$aiq.notify.error(this.$t(`${this.basePath}.validation.channel_required`));
        return false;
      }

      if (intervals.items.length < 1) {
        this.$aiq.notify.error(this.$t(`${this.basePath}.validation.intervals_required`));
        return false;
      }

      //check that every none command interval has a template
      const invalidIntervalsTemplate = intervals.items.filter(interval => (!interval.template || interval.template.length < 1)
          && interval.action !== 'command');
      if (invalidIntervalsTemplate.length > 0) {
        this.$aiq.notify.error(this.$t(`${this.basePath}.validation.group_template_required`));
        return false;
      }

      //check that every interval has an action
      const invalidIntervalsAction = intervals.items.filter(interval => !interval.action || interval.action.length < 1);
      if (invalidIntervalsAction.length > 0) {
        this.$aiq.notify.error(this.$t(`${this.basePath}.validation.group_action_required`));
        return false;
      }

      //check that every interval has a send time
      const invalidIntervalsSendTime = intervals.items.filter(interval => !interval.send_at);
      if (invalidIntervalsSendTime.length > 0) {
        this.$aiq.notify.error(this.$t(`${this.basePath}.validation.group_send_time_required`));
        return false;
      }

      return true;
    },

    async saveCampaign() {
      if (!this.validate()) return;
      try {
        //parse all group send_at to timezone and parse duration.
        const payloadCampaign = {
          ...this.campaign,
          intervals: {
            ...this.campaign.intervals,
            items: this.campaign.intervals.items.map(interval => {
              return {
                ...interval,
                duration: parseInt(interval.duration),
                // convert send_at to UTC and serialize as ISO string for the API payload
                send_at: dayjs(interval.send_at).tz(this.timezone, true).utc().toISOString(),
                ...(interval.command_type === '/note' && { command_values: [{ name: interval.command_values_note }] }),
                ...(interval.command_type === '/bot' && { command_values: [{ name: interval.enabled_bot }] }),
              };
            }),
          },
        };
        if (this.isNew) {
          await this.$store.dispatch('campaign/createCampaign', payloadCampaign);
        } else {
          const payload = {
            id: this.campaign.id,
            data: payloadCampaign,
          };
          await this.$store.dispatch('campaign/updateCampaign', payload);
        }
        this.$aiq.notify.success('Campaign saved successfully');
        await this.back(true);
      } catch (_) {
        this.$aiq.notify.error(this.$t(`${this.basePath}.error_saving`));

      }
    },
    async updateTemplate(payload, message, additionalData = {}) {
      this.completeTemplates.message_templates = payload;
      try {
        await this.$store.dispatch('configs/updateMessageTemplateConfig', this.completeTemplates);
        this.$aiq.notify.success(message || 'Message template updated successfully');
        this.closeModal();
        if (get(additionalData, 'mode', '') === 'add') {
          //if the mode is add, add the template to the current group immediately
          this.campaign.intervals.items[this.currentIndex].template = get(additionalData, 'template.title', '');
        }

      } catch (err) {
        this.$aiq.notify.error('Error updating message template');
      }
    },
    handleOpen(payload) {
      this.messageTemplateMode = payload.type;
      const index = payload.index;
      //get interval
      const interval = this.campaign.intervals.items[index];
      //if action is message, use the campaign.channel as channel to filter templates
      // else if action is notification, use notification as channel to filter templates
      const action = get(interval, 'action', '');
      if (action === 'message') {
        if (this.campaign.channel === 'sms') {
          this.addChannel = 'sms';
        } else {
          this.addChannel = 'webchat';
        }
      } else if (action === 'notification') {
        this.addChannel = 'notification';
      }
      this.modalTitle = this.$t(`${this.basePath}.message_template.${payload.type}_message_template`);
      this.selectedTemplateName = payload.value;
      this.showModal = true;
      //set current index of the group being selected
      this.currentIndex = payload.index;
    },
    closeModal() {
      this.showModal = false;
      this.selectedTemplateName = '';
    },

    handleTemplateChange(value, index) {
      this.campaign.intervals.items[index].template = value;
    },

    removeInterval(index) {
      this.campaign.intervals.items.splice(index, 1);
      // update id
      this.campaign.intervals.items = this.campaign.intervals.items.map((item, index) => {
        return {
          ...item,
          id: index + 1,
        };
      });
    },
    addInterval() {
      this.campaign.intervals.items.push({ id: this.campaign.intervals.items.length + 1, ...this.DEFAULT_INTERVAL });
    },
    async validateForChanges() {
      if (isEqual(this.campaign, this.campaignClone)) {
        return true;
      } else {
        try {
          await this.$aiq.confirm(
            this.$t('modal_editor.before_close_confirm.title'),
            this.$t('modal_editor.before_close_confirm.message', {
              name: this.campaign.name,
              defaultValue: 'modal_editor.before_close_confirm.message',
            }),
          );
          return true;
        } catch {
          return false;
        }
      }
    },
    async back(val = false) {
      if (!val) {
        const changes = await this.validateForChanges();
        if (!changes) {
          return;
        }
      }
      const currentPath = this.$route.path;
      const parentPath = currentPath.substring(0, currentPath.lastIndexOf('/'));
      // get parant name if exist
      const name = get(this.$route, 'meta.parentName');
      // move to the parent
      this.$router.push(name ? { name } : parentPath);
    },
    async getTzAbbr() {
      this.timezone = await useTimeZone(
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        this.$store.dispatch,
        this.$store._state.data.configs,
      );

      this.tzAbbr = getTimeZoneAbbr(this.timezone);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/aiq-variables.scss";

.last-grp-btn {
  display: flex;
}

.page-header {
  padding-top: 20px;
  padding-bottom: 20px;
}

.span-info {
  font-size: 15px;
}

.edit-area {
  margin: 0 30px 0 30px;
}

.field-container {
  margin-bottom: 20px;
}

.switch {
  margin-left: 20px;
}

:deep(.el-textarea__inner) {
  max-height: 200px;
  min-height: 200px !important;
}

span {
  padding-left: 10px;
  padding-right: 10px;
}

.field-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
}

.btn-group {
 margin-top: auto;
}

:deep(.ProseMirror) {
    min-height: 150px;
    max-height: 150px;
    font-size: 12px;
    padding: 10px;
  }
.group-btn {
  width: 100%;
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.position-action {
  display: flex;
  gap: 10px;
}

.group-item {
  flex: 0 0 30%;
  margin-right: 10px;
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 10px;
  border: 1px solid #A8A9AB;
  background-color: #eef1f6;
  height: 670px;
}

.question-mark {
  padding-left: 8px;
}

.group-item:last-child {
  margin-bottom: 10px;
}

.footer {
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.required-label-wrapper {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 10px;
}

.required-label {
  color: $aiq-button-create-bg;
}

.header {
  margin-left: 20px;
  margin-top: 10px;
}

.group-flext-fields {
  width: 100%;
}

:deep(.el-date-editor.el-input) {
  height: 36px !important;
  width: 100%;
}

:deep(.el-input__inner) {
  background-color: #fff !important;
  width: 100% !important;
}

:deep(.el-input.is-disabled .el-input__inner) {
  -webkit-text-fill-color: #41474d;
}

:deep(.el-textarea.is-disabled .el-textarea__inner) {
  color: #41474d;
}

:deep(.el-textarea__inner) {
  background-color: #fff !important;
}

:deep(.active .el-switch__core) {
  background-color: #5993FF !important;
  color: #5993FF !important;
}

.field-container.is-required label::before {
  margin-right: 5px;
  content: "*";
  color: #FF0000;
}

:deep(.custom-time-picker .el-input__icon) {
  margin-left: 7px !important;
}

:deep(.content-footer) {
  padding-bottom: 20px;
}

:deep(.el-date-editor .el-input__inner) {
  height: 30px !important;
}

:deep(.el-select .el-input__wrapper) {
  border-color: var(--aiq-color-border-medium) !important;
}
</style>